import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, IconButton, Typography } from '@mui/material';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationsCount } from '../hooks/useNotificationsCount';
import NotificationModal from './NotificationModal';

const badgeStyle = {
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
  },
};

export const NotificationBell: React.FC = () => {
  const { t } = useTranslation();
  const { isModalOpen, anchorEl, count, handleClick, handleClose } = useNotificationsCount();

  return (
    <>
      <IconButton
        sx={{ display: 'flex', justifyContent: 'start', gap: 2, '&:hover': {backgroundColor: 'transparent'} }}
        color="inherit"
        onClick={handleClick}
        aria-label={t('notifications.bell.ariaLabel', 'notifications')}
      >
        <Badge badgeContent={count} color="error" sx={badgeStyle}>
          <NotificationsIcon />
        </Badge>
        <Typography
          sx={{
            display: {
              xs: 'block',
              md: 'none',
            },
          }}
        >
          {t('notifications.title', 'Notifications')}
        </Typography>
      </IconButton>


      {isModalOpen && (
        <NotificationModal open={isModalOpen} anchorEl={anchorEl} onClose={handleClose} />
      )}
    </>
  );
};

export default NotificationBell;
